jQuery("body").on("tx_solr_updated", reinitFocusPointsAfterSolrAjaxUpdate);

// Reinitialize focus points after a Solr AJAX update on pagination.
function reinitFocusPointsAfterSolrAjaxUpdate() {
    let focusImages = jQuery('.focuspoint');
    if(focusImages.length) {
        focusImages.focusPoint();
    }
}